import { post } from 'api/_defaults/fetch';

export const startAgent = async ({ agent, files, config, body }) => {
    try {
        // Crea FormData per inviare i file
        const formData = new FormData();

        // Aggiungi ogni file al FormData
        files.forEach((file) => {
            formData.append('files', file);
        });

        if (body) {
            Object.keys(body).filter((key) => body[key] !== undefined).forEach((key) => {
                formData.append(key, body[key]);
            });
        }

        const data = await post(`/agents/${agent.type}/${agent._id}`, formData, { config });
        return data;
    } catch (error) {
        console.log('startAgent error:', error);
        throw error;
    }
}